<template>
    <jhs-free-lp2026 v-if="isAfter20260401" />
    <jhs-free-lp2025 v-else />
</template>

<script>
import JhsFreeLp2025 from "../pages/jhsfree/JhsFreeLp2025.vue";
import JhsFreeLp2026 from "../pages/jhsfree/JhsFreeLp2026.vue";
import * as metaInformationUtil from "../../util/metaInformationUtil";
import {mapGetters} from "vuex";
/**
 * 中学生プレミアム化LPの表示を条件に応じて切り替えるためのラッパーコンポーネント
 * 特定の条件で表示を切り替えている用途で利用している。
 * 例：
 * - 年度ごとに用意したLPコンポーネントの切り替え
 * - AB Testing
 */
export default {
    name: "JhsFreeLpRouter",
    components: {
        JhsFreeLp2025,JhsFreeLp2026
    },
    props: {
        /**
         * title
         */
        title: {
            type: String,
            required: true
        },
        /**
         * description
         */
        description: {
            type: String,
            required: true
        },
    },
    computed: {
        ...mapGetters('AccountStoreV2',[
            'accountStatus'
        ]),
        isAfter20260401() {
            return this.accountStatus.timeTripDate.isAfterTime("2026-04-01T00:00:00")
        }
    },
    mounted() {
        this.setTitleAndDesc();
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
    }
}
</script>
